import Activable from '../../../mocks/api/activable.json';
import ActivableCore from '../../../mocks/api/activable-core.json';
import ActivableCoreDetails from '../../../mocks/api/activable-core-details.json';
import Active from '../../../mocks/api/active.json';
import AppSim from '../../../mocks/api/app-sim.json';
import AppStart from '../../../mocks/api/app-start.json';
import CheckActivation from '../../../mocks/api/check-activation.json';
import PerformActivation from '../../../mocks/api/perform-activation.json';
import PerformC2goActivation from '../../../mocks/api/perform-c2go-activation.json';
import PerformRtmBookingActivation from '../../../mocks/api/perform-rtm-booking-activation.json';
import Mail from '../../../mocks/api/mail.json';
import ContextSearch from '../../../mocks/api/context-search.json';
import ClientRegister from '../../../mocks/api/client-register.json';
import Counters from '../../../mocks/api/counters.json';
import CountersCompany from '../../../mocks/api/countersCompany.json';
import Product from '../../../mocks/api/product.json';
import SessionLogin from '../../../mocks/api/session-login.json';
import SimPuk from '../../../mocks/api/sim-puk.json';
import Scrape from '../../../mocks/api/scrape.json';
import ShoppingCart from '../../../mocks/api/shopping-cart.json';
import PerformRtmRefuse from '../../../mocks/api/perform-rtm-refuse.json';
import EligibleProducts from '../../../mocks/api/eligible-products.json';
import ProductCatalog from '../../../mocks/api/product-catalog.json';
import Inventory from '../../../mocks/api/inventory.json';
import Agreements from '../../../mocks/api/agreements.json';
import CustomerWebAccount from '../../../mocks/api/customerWebAccount.json';
import GeographicAddressValidation from '../../../mocks/api/geographic-address-validation.json';
import PerformProductActivation from '../../../mocks/api/perform-product-activation.json';
import NewsList from '../../../mocks/api/news-list.json';
import NewsDetail from '../../../mocks/api/news-detail.json';
import CreateShoppingCart from '../../../mocks/api/create-shopping-cart.json';
import TaskFlowUniqueResponse from '../../../mocks/api/taskflow-update-unique-response.json';
import CreateProcessFlow from '../../../mocks/api/create-process-flow.json';
import CompleteProcessFlow from '../../../mocks/api/complete-process-flow.json';
import OrderFulfillmentStatus from '../../../mocks/api/order-fulfillment-status.json';
import AccountInfo from '../../../mocks/api/account-info.json';
import CompanyValidators from '../../../mocks/api/company-validators.json';
import CartProcessFlow from '../../../mocks/api/cart-process-flow.json';
import CreateProcessFlowError from '../../../mocks/api/create-process-flow-error.json';
import ProductCoverage from '../../../mocks/api/product-coverage.json';
import FixedAddon from '../../../mocks/api/fixed-add-on.json';
import LinkAccount from '../../../mocks/api/landline-change.json';
import FixedAddonDetails from '../../../mocks/api/fixed-add-on-detail.json';
import DeviceList from '../../../mocks/api/device-list.json';
import AppointmentAvailability from '../../../mocks/api/appointment-availability.json';
import MyProductsCounters from '../../../mocks/api/myproducts-counter.json';
import NewsListByDay from '../../../mocks/api/news-by-day.json';
import Categories from '../../../mocks/api/categories.json';
import Notifications from '../../../mocks/api/news-notifications.json';
import NotificationsAEM from '../../../mocks/api/news-notification-aem.json';
import FilteredNews from '../../../mocks/api/news-filtered.json';
export const mockApi = {
  // App
  'GET:/\\S*/v3/app/start': AppStart,
  'GET:/api/v3/app/sim/\\w+$': AppSim,
  // Client
  'GET:/\\S*/v1/client/register': ClientRegister,
  // Puk
  'GET:/ResourceInventoryManagementNg/v1/sim\\?msisdn=\\w+': SimPuk,
  // Session
  'GET:/\\S*/v1/session/login': SessionLogin,
  // Counters
  'GET:/\\S*/v2/counters/sim/\\w+': MyProductsCounters,
  'GET:/\\S*/v2/counters/company': CountersCompany,
  // Catalog
  'GET:/\\S*/v2/products-catalog/landline/activable/\\S*/details': FixedAddonDetails,
  'GET:/\\S*/v2/products-catalog/landline/activable': FixedAddon,
  'GET:/\\S*/v2/products-catalog/sim/\\w+/activable': Activable,
  'GET:/\\S*/v2/products-catalog/company/\\S*/activable/\\S*/details': ActivableCoreDetails,
  'GET:/\\S*/v2/products-catalog/company/\\S*/activable': ActivableCore,
  'GET:/\\S*/v2/products-catalog/sim/\\w+/products/\\w+/\\w+': Product,
  'GET:/\\S*/v2/products-catalog/company/retrieveDevice': DeviceList,
  'GET:/\\S*/v2/products-activation-funnels/sim/\\w+/\\w+/\\w+/activation': CheckActivation,
  'POST:/\\S*/v2/products-activation-funnels/sim/\\w+/\\w+/\\w+/activation': PerformActivation,
  'POST:/\\S*/v2/products-activation-funnels/sim/\\w+/\\w+/\\w+/activation/c2go': PerformC2goActivation,
  'POST:/ProductActivationManagement/v1/ProductActivationRequest': PerformRtmBookingActivation,
  'POST:/\\S*/v2/products-activation-funnels/sim/\\w+/\\w+/\\w+/mail': Mail,
  'POST:/\\S*/v2/anchors/contextSearch': ContextSearch,
  'GET:/\\S*/v2/products-catalog/sim/\\w+/active': Active,
  'GET:/\\S*/v2/products-catalog/sim/\\w+/shoppingCart': ShoppingCart,
  'POST:/\\S*/v2/products-catalog/shoppingCart': CreateShoppingCart,
  'POST:/ProductActivationManagement/v1/ProductActivationRefuse': PerformRtmRefuse,
  'GET:/\\S*/v2/products-catalog/customer/\\S*/inventory': Inventory,
  // Misc TODO change scraping api
  'GET:/\\S*/v3/misc/scrape': Scrape,
  // Digital Solutions
  'GET:/productselector/v3/eligibleproducts\\S*': EligibleProducts,
  'GET:/productselector/v3/productcatalog\\S*': ProductCatalog,
  'POST:/GeographicAddressManagement/v1/geographicaddressvalidation': GeographicAddressValidation,
  'POST:/productactivation/v1/productactivation': PerformProductActivation,
  // Agreements
  'GET:/\\S*/v2/agreements/customer/\\w+': Agreements,
  // Otp-Snow
  'GET:/CustomerManagementLegacy/v1/customerWebAccount\\S*': CustomerWebAccount,
  'POST:/OneTimePassword/v2/createWebToken\\S*': {},
  'PATCH:/CustomerManagementLegacy/v1/customer\\S*': {},
  'POST:/OneTimePassword/v2/chewckWebToken\\S*': {},
  // Activation Workflow
  'GET:/\\S*/v2/profile/v1/account/info/\\w+': AccountInfo,
  'GET:/\\S*/v2/products-catalog/shoppingCart': CartProcessFlow,
  'POST:/activation/v1/processFlow/': CreateProcessFlow,
  'PATCH:/processflowmanagement/v1/processflow/\\w+/taskFlow\\S*': TaskFlowUniqueResponse,
  'PATCH:/activation/v1/processFlow/\\w+': CompleteProcessFlow,
  'POST:/activation/v1/processFlow': CompleteProcessFlow,
  'GET:/processflowmanagement/v1/processflow/\\w+': OrderFulfillmentStatus, // Order fulfillment status
  'GET:/partymanagementlegacy/v2/individual/': CompanyValidators,
  // Cartagine News
  'GET:/\\S*/v2/news/v1/feed/\\w+/\\w+/': NewsDetail,
  'GET:/\\S*/v2/news/v1/feed/\\S*': NewsList,
  'GET:/api-biz-bs/news/v1/listfeed(\\?\\w+=\\w+(&\\w+=\\w+)*)?': NewsListByDay,
  // ProductCoverage
  'GET:/\\S*/v2/products-catalog/company/\\S*/productcoverage': ProductCoverage,
  //Link Account
  'GET:/\\S*/v2/profile/v1/landline': LinkAccount,
  'GET:/\\S*activation/v1/appointment': AppointmentAvailability,
  'GET:/\\S*notifications/v1/test':Notifications,
  'GET:/\\S*/configurations/push-notification.contents.json':NotificationsAEM,
  'GET:/\\S*categories-mock': Categories,
  'GET:/\\S*/news/test/feed/': FilteredNews,
  'POST:/\\S*tags-mock':{status:200}
};

export const mockErrorApi = {
  // 'POST:/v1/processflow': CreateProcessFlowError,
};


